module.exports = __webpack_public_path__ + "static/media/canLeadToHeartAttack.ca8c694b.mp3";